import { render, staticRenderFns } from "./TechCommentsGuidelines.vue?vue&type=template&id=6014a622&scoped=true&"
import script from "./TechCommentsGuidelines.vue?vue&type=script&lang=js&"
export * from "./TechCommentsGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./TechCommentsGuidelines.vue?vue&type=style&index=0&id=6014a622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014a622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6014a622')) {
      api.createRecord('6014a622', component.options)
    } else {
      api.reload('6014a622', component.options)
    }
    module.hot.accept("./TechCommentsGuidelines.vue?vue&type=template&id=6014a622&scoped=true&", function () {
      api.rerender('6014a622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/TechCommentsGuidelines.vue"
export default component.exports